// import Dashboard from 'views/Dashboard/Dashboard.jsx'
import Reports from "../views/Reports/Reports";
import Anomalies from "../views/Anomalies/Anomalies.jsx";
import Goals from "../views/Goals/Goals.jsx";
import Screens from "../views/Screens/Screens.jsx";

var companyRoutes = [
  // { path: "/my-company/home/", name: "Dashboard", icon: "pe-7s-graph", component: Dashboard },
  {
    path: "/my-company/reports/",
    name: "Relatórios",
    icon: "pe-7s-news-paper",
    component: Reports,
  },
  {
    path: "/my-company/anomalies/",
    name: "Anomalias",
    icon: "pe-7s-attention",
    component: Anomalies,
  },
  {
    path: "/my-company/goals/",
    name: "Metas",
    icon: "pe-7s-edit",
    component: Goals,
  },
  {
    path: "/my-company/screens/",
    name: "Telas",
    icon: "pe-7s-photo-gallery",
    component: Screens,
  },
];
export default companyRoutes;



// WEBPACK FOOTER //
// ./src/routes/company.jsx